import { ajax } from 'discourse/lib/ajax';
import DiscourseRoute from 'discourse/routes/discourse';
import { RANK_CLASS } from '../lib/proxyviews-seo';

export default class ProxyviewsAlternativesRoute extends DiscourseRoute {
  async model(params) {
    const data = await ajax(`/alternatives/${params.slug}.json`);
    const providers = (data.alternatives || []).map((p, i) => ({
      ...p,
      rank: i + 1,
      rankClass: RANK_CLASS[i] || '',
      ratingDisplay: p.overall_rating ? Number(p.overall_rating).toFixed(1) : '—',
      costDisplay: (p.price_range || p.real_cost_per_gb) ? `$${p.price_range || p.real_cost_per_gb}/GB` : '—',
      logoInitial: (p.name || '?').charAt(0).toUpperCase(),
      url: `/providers/${p.slug}`,
    }));
    return {
      name: data.name,
      slug: data.slug,
      title: data.title,
      metaTitle: data.meta_title,
      providers,
    };
  }

  titleToken() {
    return this.currentModel?.metaTitle || 'Alternatives';
  }
}
